module.exports = __webpack_public_path__ + "static/media/rrpspSequence.392b0e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/rrpspSequence.jpg
// module id = 478
// module chunks = 0